import ReactPixel from 'react-facebook-pixel'

import { FacebookStandardEvent } from './types'

const options = {
  autoConfig: true,
  debug: false,
}

export const initFacebookPixel = (pixelId: string) => {
  ReactPixel.init(pixelId, undefined, options)
  ReactPixel.pageView()
}

export const fbPixel = {
  track: (event: FacebookStandardEvent, data?: Record<string, any>) => {
    ReactPixel.track(event, data)
  },
  trackCustom: ReactPixel.trackCustom,
  pageView: ReactPixel.pageView,
  init: ReactPixel.init,
}
